import { render } from "./ButtonUpload.vue?vue&type=template&id=be681002&scoped=true"
import script from "./ButtonUpload.vue?vue&type=script&lang=js"
export * from "./ButtonUpload.vue?vue&type=script&lang=js"

import "./ButtonUpload.vue?vue&type=style&index=0&id=be681002&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be681002"]])

export default __exports__